// extracted by mini-css-extract-plugin
export var accordionBody = "style-mod--accordion-body--ccfe6";
export var accordionIcon = "style-mod--accordion-icon--53751";
export var accordionIconOpen = "style-mod--accordion-icon-open--2fcc8";
export var accrodionTitleIcon = "style-mod--accrodion-title-icon--0b7fe";
export var bigImageText = "style-mod--big-image-text--387b2";
export var bigImgHeadline = "style-mod--big-img-headline--3d4da";
export var bigImgText = "style-mod--big-img-text--574fc";
export var buttonBox = "style-mod--button-box--6839e";
export var imageContainer = "style-mod--image-container--48421";
export var innerContainer = "style-mod--inner-container--60825";
export var leftPart = "style-mod--left-part--0b0b2";
export var lowerPart = "style-mod--lower-part--b388a";
export var lowerPartContainer = "style-mod--lower-part-container--f5fd3";
export var lowerPartMobile = "style-mod--lower-part-mobile--d8ea2";
export var rightPart = "style-mod--right-part--b0423";
export var textBox = "style-mod--text-box--f5125";
export var textContainer = "style-mod--text-container--47e4c";
export var toggleHeader = "style-mod--toggle-header--f8511";